<template>
  <div class="important-items">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(slide, i) in initialState" :key="i">
        <a :href="slide.url" class="important-items__item">
          <span class="important-items__item-info">
            <span class="important-items__item-title">{{ slide.title }}</span>
            <span class="important-items__item-subtitle">
              {{ $t('important-items.from')}}
              <span>
                {{ slide.subtitle }}
              </span>
              {{ $t('important-items.currency')}}
            </span>
          </span>
          <span class="important-items__item-img-wrap">
            <picture>
              <source :srcset="slide.image_mob" media="(max-width: 1023px)" />
              <img
                loading="lazy"
                decoding="async"
                :src="slide.image"
                :alt="slide.title"
              />
            </picture>
          </span>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'ImportantItems',
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        preloadImages: false,
        lazy: {
          loadPrevNext: true
        },
        slidesPerView: 'auto',
        spaceBetween: 7,
        loop: false,
        autoplay: false,
        speed: 1000,
        breakpoints: {
          '768': {
            slidesPerView: 3,
            spaceBetween: 19
          }
        }
      }
    }
  },
  props: {
    initialState: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    const wrapper = document.querySelector('.important-items-wrap')
    if (wrapper) {
      wrapper.classList.remove('important-items-wrap--loading')
    }
  }
}
</script>

<style lang="sass">
.important-items .swiper-wrapper
  align-items: stretch
.important-items
  &__item
    span
      font-size: 25px
      +mbetween($large--mid, $large--ext)
        font-size: 20px
      +mbetween($large, $large--mid)
        font-size: 20px
      +mbetween($tablet--hor, $large)
        font-size: 16px
      +mbetween($tablet, $tablet--hor)
        font-size: 20px
      +mmax($tablet)
        font-size: 22px
</style>

<style scoped lang="sass">
@import "../../styles/swiper/swiper"
.swiper
  position: absolute
  left: 0
  top: 0
  width: 100%
.swiper-item
  height: auto
  +mmax($tablet)
    width: 270px !important
.important-items
  position: absolute
  left: 0
  top: 0
  width: 100%
  &__item
    border-radius: 4.198px
    background: #F5F5F5
    display: flex
    text-decoration: none
    transition: background 0.2s
    height: 100%
    &:hover
      background: #E7E7E7
    +mmax($tablet)
      width: 270px !important
    &-subtitle
      color: #2E2E2E
      font-size: 18px
      font-style: normal
      font-weight: 500
      line-height: normal
      +mmax($tablet--hor)
        font-size: 16px
    &-title
      color: #2E2E2E
      font-size: 14px
      font-style: normal
      font-weight: 500
      line-height: normal
      margin-bottom: auto
      +mbetween($tablet--hor, $large)
        font-size: 12px
      +mmax($tablet)
        font-size: 16px
    &-info
      flex-grow: 1
      padding: 17px 5px 17px 17px
      display: flex
      flex-direction: column
      +mbetween($tablet--hor, $large)
        padding: 13px 5px 13px 13px
      +mmax($tablet)
        padding: 20px 10px 20px 20px
    &-img-wrap
      width: 149px
      flex-shrink: 0
      position: relative
      font-size: 0
      padding-top: 26.9%
      margin-top: 4px
      +mbetween($large, $large--mid)
        width: 115px
      +mmax($large)
        width: 100px
      +mmax($tablet--hor)
        padding-top: 36.9%
      +mmax($tablet)
        padding-top: 38.5%
        margin: 0 10px 0 0

    img
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: 100%
</style>
